import type { CategoryImportPreset, ImportPreset } from './types'

/**
 * Пресеты импорта прайсов из популярных систем РФ.
 *
 * Заголовки перечислены в вариантах, которые реально встречаются в выгрузках.
 * Сопоставление идёт регистронезависимо и по нормализованным пробелам
 * (см. ExcelParser.normalizeHeader).
 */

export const KONTUR_PRESET: ImportPreset = {
  id: 'kontur',
  label: 'Контур.Маркет',
  mapping: {
    name: ['наименование', 'название товара', 'товар'],
    barcode: ['штрихкод', 'штрих-код', 'ean'],
    price: ['цена', 'цена продажи', 'розничная цена'],
    stock: ['остаток', 'количество', 'кол-во'],
    unit: ['ед. изм.', 'единица измерения', 'ед'],
    category: ['категория', 'категория товара', 'category'],
    subcategory: ['подкатегория', 'подкатегория товара', 'subcategory']
  }
}

export const SBIS_PRESET: ImportPreset = {
  id: 'sbis',
  label: 'СБИС',
  mapping: {
    name: ['название', 'наименование товара'],
    barcode: ['код товара', 'штрихкод', 'штрих код'],
    price: ['цена, руб', 'цена руб', 'цена'],
    stock: ['остаток', 'склад'],
    unit: ['ед.изм', 'единица'],
    category: ['категория', 'категория товара', 'category'],
    subcategory: ['подкатегория', 'подкатегория товара', 'subcategory']
  }
}

export const FUSIONPOS_PRESET: ImportPreset = {
  id: 'fusionpos',
  label: 'FusionPOS',
  mapping: {
    name: ['наименование', 'название', 'product name', 'name'],
    // ВАЖНО: 'штрих код'/'штрихкод' должны иметь приоритет над любым 'код'.
    // В старой выгрузке есть колонка «Код товара» (внутренний ID вроде 1102),
    // которую НЕЛЬЗЯ принимать за штрихкод — реальный EAN лежит в «Штрих код».
    // Поэтому голый 'код'/'код товара' в этот список НЕ включаем.
    barcode: ['штрихкод', 'штрих код', 'barcode', 'sku'],
    price: ['цена', 'цена продажи', 'retail price', 'price'],
    stock: ['остаток', 'qty', 'quantity', 'stock'],
    unit: [
      'единица измерения (кг, г, мг, л, мл, шт, упак, пц, м, см)',
      'единица измерения',
      'выход',
      'unit',
      'uom',
      'ед'
    ],
    category: ['категория меню', 'категория', 'категория ингредиента', 'category'],
    subcategory: ['подкатегория', 'подкатегория меню', 'subcategory'],
    isWeight: ['весовой (да, нет)', 'весовой', 'is_weight']
  }
}

export const ONE_C_PRESET: ImportPreset = {
  id: '1c',
  label: '1С',
  mapping: {
    name: ['номенклатура', 'наименование', 'товар'],
    barcode: ['штрихкод', 'штрих-код', 'код'],
    price: ['цена', 'цена, руб.', 'цена продажи'],
    stock: ['остаток', 'количество'],
    unit: ['ед. изм.', 'базовая единица', 'единица'],
    category: ['категория', 'группа', 'category'],
    subcategory: ['подкатегория', 'подгруппа', 'subcategory']
  }
}

/** Все пресеты в порядке приоритета авто-детекта. */
export const PRESETS: ImportPreset[] = [
  KONTUR_PRESET,
  SBIS_PRESET,
  FUSIONPOS_PRESET,
  ONE_C_PRESET
]

/**
 * Пресет выгрузки категорий.
 *
 * В источнике верхний уровень помечается значением в колонке «Категория»
 * (например, «Главный экран»). Это значение — настройка адаптера, а не
 * понятие домена: в модели верхний уровень = `parentName = null`.
 */
export const FUSIONPOS_CATEGORY_PRESET: CategoryImportPreset = {
  id: 'fusionpos-categories',
  label: 'FusionPOS — категории',
  mapping: {
    name: ['название', 'наименование', 'name'],
    parent: ['категория', 'родитель', 'родительская категория', 'parent'],
    department: ['отдел', 'department'],
    isActive: ['активно', 'активна', 'active'],
    imageUrl: ['изображение', 'image', 'image url']
  },
  rootMarkers: ['главный экран']
}

/** Все пресеты выгрузок категорий. */
export const CATEGORY_PRESETS: CategoryImportPreset[] = [FUSIONPOS_CATEGORY_PRESET]
